module.exports = __webpack_public_path__ + "img/guide.a4bd1249.png";